import $ from 'jquery'

/**
 * Requests an animation frame.
 *
 * @param callback
 * @returns {*}
 */
export function frame(callback)
{
	if(typeof requestAnimationFrame == 'undefined')
	{
		return setTimeout(callback, 0)
	}

	return requestAnimationFrame(callback)
}

/**
 * Cancels a frame request.
 *
 * @param id
 */
export function unframe(id)
{
	if(typeof cancelAnimationFrame == 'undefined')
	{
		return clearTimeout(id)
	}

	return cancelAnimationFrame(id)
}

/**
 * Triggers a layout reflow for a specific element.
 *
 * @param element
 */
export function redraw(element)
{
	if(element instanceof $)
	{
		element = element[0]
	}

	// Accessing this property triggers a layout reflow
	element.offsetWidth
}

/**
 * Crude check to see if the device is a touch screen.
 *
 * @returns {boolean}
 */
export function isTouch()
{
	// @see http://stackoverflow.com/a/4819886/556609
	return ('ontouchstart' in window || !!navigator.maxTouchPoints)
}

/**
 * Crude check to see if the browser is IE.
 *
 * @param version - Optionally check a specific version (11, 10, or 9)
 * @returns {boolean}
 */
export function isIE(version = null)
{
	const ua = navigator.userAgent
	const is11 = /rv:11.0/i.test(ua)
	const is10 = /MSIE 10/i.test(ua)
	const is9 = /MSIE 9/i.test(ua)

	switch(version)
	{
		case 11: return is11
		case 10: return is10
		case  9: return is9
	}

	return is11 && is10 && is9
}

/**
 * Loads an external Javascript file and executes it
 *
 * @param url - The URL to the Javascript file
 * @param callback - A function to call after the script has been executed
 * @param check - An optional function to return a boolean for manually checking if the script has correctly executed.
 *   This ensures that the callback actually happens after the script has been executed. For example, if loading jQuery
 *   this function could check whether the jQuery property exists on the window object.
 */
let loadedDependencies = null
export function dependency(url, callback = function() {}, check = () => true)
{
	if(!loadedDependencies)
	{
		loadedDependencies = {}

		$('script[src]').each(function()
		{
			const src = $(this).prop('src')
			loadedDependencies[src] = 1
		})
	}

	const poll = function()
	{
		if(check())
		{
			callback()
		}
		else
		{
			setTimeout(poll, 20)
		}
	}

	if(!loadedDependencies[url])
	{
		loadedDependencies[url] = 1

		$.getScript(url, poll)
	}
	else
	{
		poll()
	}
}



// WEBPACK FOOTER //
// ./source/scripts/utilities.js